export default "__VITE_ASSET__5d96dd4f__"